module.exports = __webpack_public_path__ + "static/img/bg_4.17addfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_4.png
// module id = 777
// module chunks = 1